import { useCallback } from 'react';

import useRegularOptions from '@/components/Chart/hooks/options/useRegularOptions';
import { ExtendedOptions, ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';
import { regularChartPalette } from '@/constants/constants';

const useSpotOptions = (height?: number, isDhChart = false) => {
  const { createOptions: createRegularOptions } = useRegularOptions(height, isDhChart);

  const createOptions = useCallback((chartSeries: ExtendedSeriesOptionsType[]): ExtendedOptions => {
    chartSeries = chartSeries.map(series => {
      const { combinedIndex } = series.custom;

      series.color ??=
        combinedIndex > 5
          ? '#F8F8F8'
          : (series.custom.color ??
            regularChartPalette[combinedIndex % regularChartPalette.length]);

      return series;
    });
    return createRegularOptions(chartSeries);
  }, []);

  return { createOptions };
};

export default useSpotOptions;
